
class ActionStateFactory {
    static async extract(actionState) {
        switch (actionState.type) {
            case "Step menu frame":
                await StepInstructionScreenManager.loadStateForServerLess(actionState);
                break;
            default:
                console.warn("Unknown action state type:", actionState.type);
        }
    }
}

export default ActionStateFactory;
